

/*
FrFr FRIENDLY FRAMEWORK
frfr-dynamic-js-utils
Version ID: 1a 2024-02-08r1
by 
// Please describe here if you customized this file
*/


//
export const dynamicjs_load_script_file = (url, cb) => {
  // url is URL of external file, implementationCode is the code to be called from the file, location is the location to insert the <script> element
  const scriptTag = document.createElement('script');
  scriptTag.src = url;
  // scriptTag.type = 'text/javascript'; // Indicates that the script is a "classic script", containing JavaScript code. Authors are encouraged to omit the attribute if the script refers to JavaScript code rather than specify a MIME type.

  // Then bind the event to the callback function.
  // There are several events for cross browser compatibility.
  scriptTag.onload = cb;
  // scriptTag.onreadystatechange = cb;

  // Adding the script tag to the head as suggested before
  const targetEl = document.head;

  // Fire the loading
  targetEl.appendChild(scriptTag);
};


//
export const dynamicjs_load_script_string = (js_script_str, cb) => {
  // https://code-boxx.com/dynamically-load-javascript/


  // url is URL of external file, implementationCode is the code to be called from the file, location is the location to insert the <script> element
  const scriptTag = document.createElement('script');
  scriptTag.textContent = js_script_str; // textContent gets the content of all elements, including <script> and <style> elements. In contrast, innerText only shows "human-readable" elements.
  scriptTag.type = 'text/javascript'; // Indicates that the script is a "classic script", containing JavaScript code. Authors are encouraged to omit the attribute if the script refers to JavaScript code rather than specify a MIME type.

  // cb cant be run because ther is no onload event and there is nothing to load

  // Adding the script tag to the head as suggested before
  const targetEl = document.head;

  // Fire the loading
  targetEl.appendChild(scriptTag);
};

